import axios from '@/libs/api.request'

/**
 * 非标品/标品拣货台-SPU—SKU—入库批次号查询
 * @author gengjipeng
 * @date 2020-10-29
 * @param spu_id
 * @returns {Promise<void>}
 */
export const querySkuBatchNo = (data) => {
  return axios.request({
    url: '/api/v1/traceSource/querySkuBatchNo',
    data,
    method: 'post'
  })
}

/**
 * 非标品/标品拣货台-SPU—SKU—入库批次号查询 根据订单号查询
 * @author gengjipeng
 * @date 2020-10-29
 * @param spu_id
 * @returns {Promise<void>}
 */
export const querySkuBatchNoByOrder = (data) => {
  return axios.request({
    url: '/api/v1/traceSource/querySkuBatchNoByOrder',
    data,
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/traceSource/trace_source.js